import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import { TagModel } from 'models';

import { Card } from 'core/ui';

import { useApiClient } from 'features/api';

import { TagsFieldAccordion } from './TagsFieldAccordion';

/**
 * Demo component for showcasing the TagsFieldAccordion in an exam-reading context
 */
export const ExamReadingTagsDemo: React.FC = () => {
  const apiClient = useApiClient();
  const [tags, setTags] = useState<TagModel[]>([]);
  const [selectedTags, setSelectedTags] = useState<TagModel[]>([]);

  // Handle selected tags change from TagsFieldAccordion
  const handleSelectedTagsChange = (newSelectedTags: TagModel[]) => {
    setSelectedTags(newSelectedTags);
  };

  useEffect(() => {
    const fetchTags = async () => {
      if (apiClient.tagsClient?.getLevelTags) {
        try {
          const newTags = await apiClient.tagsClient.getLevelTags();
          setTags(newTags);
        } catch (error) {
          console.error('Error fetching tags:', error);
        }
      }
    };

    fetchTags();
  }, [apiClient.tagsClient]);

  return (
    <Container>
      <StyledCard>
        <CardHeader>Exam Reading Tags</CardHeader>
        <CardBody>
          <TagsFieldAccordion eventKey="tags" tags={tags} selectedTags={selectedTags} onSelectedTagsChange={handleSelectedTagsChange} />
        </CardBody>
      </StyledCard>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
`;

const StyledCard = styled(Card)`
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const CardHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.palette.grayscale[3]};
  font-weight: bold;
  font-size: 18px;
`;

const CardBody = styled.div`
  padding: 0;
`;

export default ExamReadingTagsDemo;
